import React, { useState, useEffect } from "react";
import { useTranslation } from "@ca-dmv-radv/translation";
import { Button } from "@ca-dmv/core";
import { getSelfieFromBackend } from "@ca-dmv-radv/data";
import LoadingIndicator from "./Loader";
import "./ReviewPhoto.css";

function ReviewPhotoTemplate({
  image,
  onRetry,
  onApprove,
  retryLabel,
  approveLabel,
  subtitleLabel,
  instructionLabel,
}) {
  const { t } = useTranslation();
  const [displayImage, setDisplayImage] = useState(image);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!image) {
      const fetchImage = async () => {
        setIsLoading(true);
        try {
          const response = await getSelfieFromBackend();
          if (response.success && response.image) {
            setDisplayImage(response.image);
          }
        } catch (error) {
          console.error("Failed to fetch image from backend:", error);
        } finally {
          setIsLoading(false);
        }
      };
      fetchImage();
    } else {
      setDisplayImage(image);
    }
  }, [image]);

  if (isLoading) {
    return (
      <div className="review-container flex--align-center flex--justify-center">
        <LoadingIndicator />
        <p className="mt-16">
          {t("screens-loading-image", "Loading image...")}
        </p>
      </div>
    );
  }

  return (
    <div className="review-container">
      <div className="review-header-custom">
        <span className="review-title">
          {subtitleLabel || "Review Photo Before Processing"}
        </span>
      </div>

      <div className="image-preview-wrapper">
        <div className="image-frame">
          <img
            src={displayImage || "placeholder-image-url"}
            alt="Selfie Preview"
            className="preview-img"
          />
        </div>
      </div>

      <div className="review-instructions">
        <p>
          {instructionLabel ||
            t(
              "screen-modal-presence-verification-review-instruction",
              `If you are not satisfied with the photo, please select '${retryLabel || "Retake"
              }' to take it again.`
            )}
        </p>
      </div>

      <div className="review-actions">
        <Button buttonClass="btn--secondary" onClick={onRetry}>
          {retryLabel ||
            t("screen-modal-presence-verification-review-retry", "Retake")}
        </Button>
        <Button buttonClass="btn--primary" onClick={onApprove}>
          {approveLabel ||
            t("screen-modal-presence-verification-review-approve", "Submit")}
        </Button>
      </div>
    </div>
  );
}

export default ReviewPhotoTemplate;
